import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { QrBox } from "@/components/accordi/AccordoKit";
import { toast } from "sonner";
import { Mail, UserX } from "lucide-react";

const AccessiReferenti = ({ accordo }) => {
  const [list, setList] = useState([]);
  const [email, setEmail] = useState(accordo.referente_principale?.email || "");
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/admin/accordi/${accordo.id}/referenti-accesso`).then(({ data }) => setList(data));
  useEffect(() => { load(); }, [accordo.id]); // eslint-disable-line
  const invita = async (em, nome) => {
    setBusy(true);
    try { await api.post(`/admin/accordi/${accordo.id}/referenti-accesso`, { email: em, nome, origin: window.location.origin }); toast.success(`Invito inviato a ${em}`); load(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const revoca = async (u) => { await api.post(`/admin/accordi/${accordo.id}/referenti-accesso/${u.id}/revoca`); toast.success("Accesso revocato"); load(); };
  const inviaReport = async () => {
    try { const { data } = await api.post(`/admin/accordi/${accordo.id}/invia-report`); toast.success(`Report del mese scorso inviato a ${data.destinatari.join(", ")}`); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="space-y-3" data-testid="accessi-referenti">
      <p className="text-sm text-muted-foreground">Il referente riceve un'email per scegliere la password e vede solo dati aggregati del suo accordo.</p>
      <div className="flex gap-2">
        <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email del referente" data-testid="accessi-email" />
        <Button onClick={() => invita(email, accordo.referente_principale?.email === email ? accordo.referente_principale?.nome : "")} disabled={!email || busy} data-testid="accessi-invita" className="gap-1.5 bg-forest hover:bg-forest-hover"><Mail className="h-4 w-4" />Invita</Button>
      </div>
      {list.map((u) => (
        <div key={u.id} className="flex items-center justify-between rounded-lg border px-3 py-2 text-sm" data-testid={`accesso-${u.email}`}>
          <div><div className="text-forest">{u.email}</div><div className="text-xs text-muted-foreground">{!u.attivo ? "Revocato" : u.attivato ? `Attivo${u.ultimo_accesso ? ` · ultimo accesso ${new Date(u.ultimo_accesso).toLocaleString("it-IT")}` : ""}` : "Invito inviato, in attesa di attivazione"}</div></div>
          <div className="flex gap-1">
            <Button size="sm" variant="ghost" onClick={() => invita(u.email, u.nome)} data-testid={`accesso-reinvita-${u.email}`}>Reinvia</Button>
            {u.attivo && <Button size="sm" variant="ghost" onClick={() => revoca(u)} data-testid={`accesso-revoca-${u.email}`} className="text-red-700"><UserX className="h-4 w-4" /></Button>}
          </div>
        </div>
      ))}
      <div className="border-t pt-3 text-xs text-muted-foreground">
        Report mensile automatico: <b data-testid="accessi-report-stato">{accordo.report_mensile_referente ? "attivo" : "disattivato"}</b> (si cambia da Modifica accordo).
        <Button size="sm" variant="outline" onClick={inviaReport} data-testid="accessi-invia-report" className="ml-2 h-7">Invia ora il report del mese scorso</Button>
      </div>
    </div>
  );
};

// QR code stampabile + accessi dashboard dei referenti dell'ente.
export const AccordoCondividi = ({ accordo, onOpenChange }) => (
  <Dialog open={!!accordo} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-2xl" data-testid="accordo-condividi">
      <DialogHeader><DialogTitle className="font-heading text-forest">{accordo?.codice} — QR code e accessi referenti</DialogTitle></DialogHeader>
      {accordo && <div className="grid gap-4 md:grid-cols-2"><QrBox accordo={accordo} /><AccessiReferenti accordo={accordo} /></div>}
    </DialogContent>
  </Dialog>
);
